import '../css/header.css';
import { Container, Nav, Navbar, NavDropdown, Button } from 'react-bootstrap';

function Header() {
  return (
    <Navbar expand="lg" className="header" fixed='top' sticky='top'>
      <Container fluid className="d-flex align-items-center">
        <Navbar.Brand href="/"><h2><b>PathWay</b></h2></Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav"/>
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link href="/">Home</Nav.Link>
            {/* <Nav.Link href="#link">Services</Nav.Link>
            <NavDropdown title="Resources" id="basic-nav-dropdown">
              <NavDropdown.Item href="#action/3.1">Action</NavDropdown.Item>
              <NavDropdown.Item href="#action/3.2">
                Another action
              </NavDropdown.Item>
              <NavDropdown.Item href="#action/3.3">Something</NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item href="#action/3.4">
                Separated link
              </NavDropdown.Item>
            </NavDropdown>
            <Nav.Link href="#link">About</Nav.Link> */}
          </Nav>
          <Button className='SignUpButton' onClick={() => window.alert('Thank you for considering my application!')}>Sign Up</Button>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default Header;

// needs work